import React from "react"
import Layout from "../components/Layout"
import { graphql } from "gatsby"
import Projects from "../components/Projects"
import SEO from "../components/SEO"

const ProjectsPage = ({
  data: { allStrapiProjects: { nodes: projects}}
}) => {
  return <Layout>
    <SEO title="Projects" description="AKHADAM AYOUB's projects" />
    <section className="projects-page">
      <Projects projects={projects} title="All projects"  />
    </section>
  </Layout>
}

export default ProjectsPage

export const query = graphql`
  {
    allStrapiProjects(sort: {fields: strapiId, order: DESC}) {
      nodes {
        github
        id
        description
        title
        url
        image {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        stack {
          id
          name
        }
      }
    }
  }
`
